"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParserError = void 0;
class ParserError extends Error {
    constructor(reader, message) {
        const { line, character } = reader.getStringPosition();
        super(`Parse error at ${line}:${character}: ${message}`);
    }
}
exports.ParserError = ParserError;
//# sourceMappingURL=parser_error.js.map